import { GetShortsRequest, GetShortsResponse } from '@weave/schema-gen-ts/dist/schemas/threads-of-success/v2/api.pb';
import { useQuery, UseQueryOptions } from 'react-query';
import { SchemaThreadsOfSuccessServiceV2 } from './service';

export const queryKeys = {
  base: 'threads-of-success-v2',
  getShorts: (req: GetShortsRequest) => [queryKeys.base, 'get-shorts', req],
};

const defaultOptions = {
  retry: false,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};

const ONE_HOUR_MS = 1000 * 60 * 60;
export const useGetShorts = (
  req: GetShortsRequest,
  options: UseQueryOptions<GetShortsResponse, unknown, GetShortsResponse>
) =>
  useQuery({
    ...defaultOptions,
    cacheTime: ONE_HOUR_MS, // since this is unlikely to change often, cache for an hour
    queryKey: queryKeys.getShorts(req),
    queryFn: () => SchemaThreadsOfSuccessServiceV2.GetShorts(req),
    ...options,
  });
